<cmps-dialog
    class="cmps-cdk-p-0 cmps-cdk-overflow-hidden cmps-cdk-border-width-0p"
>
    <cmps-dialog-body class="cmps-cdk-h-100p">
        <div
            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-px-1 cmps-cdk-py-0dot5 cmps-cdk-bg-color-unknown-123 cmps-cdk-cg-0dot5"
            *ngIf="!_service.state?.pending?.reload"
        >
            <div class="cmps-cdk-flex-grow-1">
                <div>
                    <input
                        type="text"
                        class="cmps-cdk-border-width-0p cmps-cdk-bg-color-unknown-123 cmps-cdk-w-100pct cmps-cdk-font-size-20p cmps-cdk-color-white cmps-cdk-h-24px"
                        [placeholder]="
                            _service.state?.transcript | cmpsTranscriptTitle
                        "
                        [ngModel]="_service.state?.transcript?.name"
                        [ngModelOptions]="{ updateOn: 'blur' }"
                        (ngModelChange)="_onTitleChange($event)"
                    />
                    <div
                        class="cmps-cdk-font-size-10p cmps-cdk-color-unknown-121 cmps-cdk-font-italic"
                        *ngIf="_service.state?.transcript?.transcriptId != null"
                    >
                        {{ _i18n._10058_CREATED_ON_ | translate }}
                        {{
                            _service.state?.transcript?.createdOn
                                | cmpsDate: 'EEEE, MMMM d, y, h:mm:ss a'
                        }}
                    </div>
                </div>
            </div>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._11211_BACK | translate"
                    trigger="hover"
                    (click)="_onBackClick()"
                    *ngIf="
                        _service.state?.view === _View.NOTES &&
                        _service.state?.hasCoachAssist === true
                    "
                >
                    <cmps-icon
                        class="cmps-cdk-bg-color-transparent cmps-cdk-fill-white hover:cmps-cdk-fill-unknown-121"
                        svgIcon="arrow-left"
                    ></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [disabled]="_service.state?.pending.updateTranscript"
                    [cmpsTooltipTrigger]="_i18n._10020_SAVE | translate"
                    trigger="hover"
                >
                    <cmps-icon
                        class="cmps-cdk-bg-color-transparent cmps-cdk-fill-white hover:cmps-cdk-fill-unknown-121"
                        svgIcon="content-save-outline"
                    ></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="
                        (!_dialogRef.expanded
                            ? _i18n._9977_EXPAND
                            : _i18n._9978_COLLAPSE
                        ) | translate
                    "
                    trigger="hover"
                    (click)="
                        !_dialogRef.expanded
                            ? _dialogRef.expand()
                            : _dialogRef.collapse()
                    "
                >
                    <cmps-icon
                        class="cmps-cdk-bg-color-transparent cmps-cdk-fill-white hover:cmps-cdk-fill-unknown-121"
                        [svgIcon]="
                            !_dialogRef.expanded
                                ? 'arrow-expand'
                                : 'arrow-collapse'
                        "
                    ></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                    trigger="hover"
                    (click)="_dialogRef.close()"
                >
                    <cmps-icon
                        class="cmps-cdk-bg-color-transparent cmps-cdk-fill-white hover:cmps-cdk-fill-unknown-121"
                        svgIcon="close"
                    ></cmps-icon>
                </button>
            </div>
        </div>
        <div class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-h-100p">
            <div
                class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-flex-grow-1 cmps-cdk-p-1"
                *ngIf="_service.state?.pending?.reload"
            >
                <cmps-wait-status></cmps-wait-status>
            </div>
            <ng-container *ngIf="!_service.state?.pending?.reload">
                <div class="cmps-cdk-flex-grow-1">
                    <cmps-transcript-dialog-landing
                        *ngIf="_service.state?.view === _View.LANDING"
                    ></cmps-transcript-dialog-landing>
                    <cmps-transcript-dialog-notes-page
                        *ngIf="_service.state?.view === _View.NOTES"
                    ></cmps-transcript-dialog-notes-page>
                </div>
            </ng-container>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
